import {pgettext} from "@/utils/translate";

export const DeviceStatus = {
    WAITING_FOR_AUTH: 'WAITING_FOR_AUTH',
    ACTIVE: 'ACTIVE',
    BLOCKED: 'BLOCKED',
}

export const DeviceStatusLabel = {
    WAITING_FOR_AUTH: pgettext('device_status', 'Waiting for authentication'),
    ACTIVE: pgettext('device_status', 'Active'),
    BLOCKED: pgettext('device_status', 'Blocked'),
}
